module.exports = __webpack_public_path__ + "static/media/beetle.2fa5830f.svg";